// extracted by mini-css-extract-plugin
export default {"container":"wVQpT8VUDSHfpnnWAWUd"};